<template>
  <div class="page_setNewSalaryTemp">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>新建模板</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="导入表字段" name="0" disabled></el-tab-pane>
          <el-tab-pane label="系统与导入表字段映射" name="1" disabled></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex" v-if="activeName=='1'">
          <el-button type="success" size="small" @click="EnableAll">一键启用所有</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:601px" v-if="activeName=='0'">
          <el-table-column prop="Name" label="导入表字段名称" width="300" align="center">
            <template slot="header">
              <div class="importTableHeadBox">
                <span>导入表字段名称</span>
                <!-- <el-button type="primary" size="small" @click="importTableHead" style="margin-left:15px">导入表头</el-button> -->
                <el-upload class="table_upload" action="" :on-change="importTableHead" :auto-upload="false" :show-file-list="false" :multiple="false">
                  <el-button type="primary" size="small" style="margin-left:15px">导入表头</el-button>
                </el-upload>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ColumnNum" label="在导入表中的列位置" width="300" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{numberToExcelColumn(row.ColumnNum)}}</template>
          </el-table-column>
        </el-table>
        <div v-if="tableData.length>0 && activeName=='0'" class="botBtnBox">
          <el-button @click="cancel">返 回</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="nextStep">表头无误，下一步</el-button>
        </div>

        <el-table :data="sysTable" border class="doc_table" v-loading="loading" style="width:621px;margin-bottom:30px" v-if="activeName=='1'">
          <el-table-column prop="SVal" label="系统字段" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Val" label="对应导入表对应字段" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Enabled" label="系统字段状态" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ColumnNum" label="操作" width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row,$index}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="stop(row,$index,row.Enabled=='停用' ? '启用' : '停用')">{{row.Enabled=='停用' ? '启用' : '停用'}}</el-button>
                <el-button type="text" @click="edit(row,$index)">编辑</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-form :model="ImportTemp" :rules="rules" v-if="activeName=='1'">
          <el-form-item label="保存为模板" label-width="100px" prop="TempName">
            <el-input v-model="ImportTemp.TempName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="是否系统所有用户可见" label-width="160px" prop="IsAllUsers">
            <el-radio-group v-model="ImportTemp.IsAllUsers">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div v-if="activeName=='1'" class="botBtnBox">
          <el-button @click="goback">上一步</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="submitSave">保存</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="编辑对应关系" :visible.sync="showEdit" width="600px">
      <el-form>
        <el-form-item :label="'系统字段 “' + info.SVal + '” 等于：'  " label-width="200px" prop="TempName">
          <el-select v-model="editName" placeholder="请选择导入表字段" size="small" style="width: 300px;" clearable filterable>
            <el-option v-for="(item,index) in tableData" :key="index" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEdit()">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          id: '',
          tempName: 'ApplySalaryTemp'
        },
        activeName: 0,
        tableData: [],
        roletype: localStorage.loginRoletype,
        loading: false,
        sysTable: [], //系统字段
        showEdit: false,
        info: {},
        editName: '', //导入表字段名称
        index: 0, //编辑的index
        ImportTemp: {
          Id:'',
          ProjectName: '', //项目名称
          ProjectId: '', //
          TempName: '', //模板名称
          IsAllUsers: '0', //是否系统所有用户可见 1是 0否
          BusinessType: '1',
          ImportTemplateUrl: '', //导入表头url
        },
        rules: {
          TempName: {
            required: true,
            message: '请输入模板名称',
            trigger: 'blur'
          },
        },
      }
    },
    created() {
      if (this.$route.query.Id != undefined && this.$route.query.Id) {
        this.listQuery.id = this.$route.query.Id;
        this.getImportTempDetail('1');
      } else if (this.$route.query.ProjectName != undefined && this.$route.query.ProjectName) {
        this.ImportTemp.ProjectName = this.$route.query.ProjectName;
        this.ImportTemp.ProjectId = this.$route.query.ProjectId;
        this.ImportTemp.TempName = this.$route.query.ProjectName + '01';
        this.getImportTempDetail('0');
      }

    },
    methods: {
      checkPermission,
      //获取系统默认字段
      getImportTempDetail(activeName) {
        xz.getImportTempDetail(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.sysTable = res.data.STempDictList;
            let ImportTemp = res.data.ImportTemp;
            this.ImportTemp = {
              Id:ImportTemp.Id,
              ProjectName: ImportTemp.ProjectName ? ImportTemp.ProjectName : this.ImportTemp.ProjectName, //项目名称
              ProjectId: ImportTemp.ProjectId ? ImportTemp.ProjectId : this.ImportTemp.ProjectId, //
              TempName: ImportTemp.TempName ? ImportTemp.TempName : this.ImportTemp.TempName, //模板名称
              IsAllUsers: ImportTemp.IsAllUsers ? ImportTemp.IsAllUsers :this.ImportTemp.IsAllUsers, //是否系统所有用户可见 1是 0否
              BusinessType: ImportTemp.BusinessType ? ImportTemp.BusinessType : this.ImportTemp.BusinessType,
              ImportTemplateUrl: ImportTemp.ImportTemplateUrl, //导入表头url
            }
            this.activeName = activeName;
            if(this.ImportTemp.ImportTemplateUrl){
              xz.getExcelHeadByUrl(this.ImportTemp.ImportTemplateUrl, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.tableData = res.data;
              } else {
                this.tableData = [];
              }
            })
            }
          } else {
            this.sysTable = [];
          }
        })
      },
      importTableHead(file) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "empexcel");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.raw.name);
        xz.uploadCert(formData).then((r) => {
          if (r) {
            this.ImportTemp.ImportTemplateUrl = r;
            xz.getExcelHeadByUrl(r, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.tableData = res.data;
              } else {
                this.tableData = [];
              }
            })
          } else {
            this.ImportTemp.ImportTemplateUrl = '';
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      //数字转EXCEL列号
      numberToExcelColumn(number) {
        let result = '';
        while (number > 0) {
          let remainder = (number - 1) % 26;
          let a = String.fromCharCode(65 + remainder);
          result = a + result;
          number = (number - remainder) - 26;
        }
        return result;
      },
      //下一步
      nextStep() {
        this.loading = true;
        if(this.tableData[0].Name=='序号'){
          this.tableData.splice(0,1)
        }
        this.sysTable.forEach((element, index) => {
          if (this.tableData[index] != undefined) {
            this.$set(element, 'Val', this.tableData[index].Name)
          }
          if (index + 1 == this.sysTable.length) {
            this.activeName = '1';
            this.loading = false;
          }
        });
      },
      //编辑
      edit(row, index) {
        this.editName = '';
        this.info = row;
        this.index = index;
        this.showEdit = true;
      },
      confirmEdit() {
        this.$set(this.sysTable[this.index], 'Val', this.editName);
        this.showEdit = false;
      },
      //停用/启用
      stop(row, index,ststus){
        this.$set(row, 'Enabled', ststus);
      },
      //取消
      cancel() {
        this.$router.go(-1);
      },
      //上一步
      goback() {
        this.activeName = '0';
      },
      submitSave() {
        let data = {
          ImportTemp: this.ImportTemp,
          STempDictList: this.sysTable
        }
        xz.addUpdataImportTempList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功')
            this.$router.go(-1);
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      EnableAll(){
        this.sysTable.forEach(element => {
          this.$set(element,'Enabled','启用')
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .importTableHeadBox {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .botBtnBox {
    width: 600px;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
</style>
<style>
  .page_setNewSalaryTemp .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_setNewSalaryTemp .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
   .page_setNewSalaryTemp .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>